import type { ApiError, VisualizeResponse } from './types';

const DEFAULT_API_BASE_URL = 'https://mani1972-ortl-api.hf.space';

const API_BASE_URL =
  (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(/\/$/, '') ??
  DEFAULT_API_BASE_URL;

export class VisualizationError extends Error {
  constructor(public readonly detail: ApiError, public readonly status: number) { super(detail.message); }
}

export async function visualizeRTL(source: string, filename = 'design.sv', topModule?: string, signal?: AbortSignal): Promise<VisualizeResponse> {
  let response: Response;
  try {
    response = await fetch(`${API_BASE_URL}/api/v1/visualize`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ source, language: filename.endsWith('.v') ? 'verilog' : 'systemverilog', filename, topModule }),
      signal,
    });
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') throw error;
    throw new VisualizationError({ code: 'BACKEND_UNAVAILABLE', message: 'The RTL analysis service is unavailable. Check the backend URL and try again.', diagnostics: [], requestId: 'network' }, 0);
  }
  const payload = await response.json().catch(() => null) as VisualizeResponse | { error?: ApiError } | null;
  if (!response.ok || !payload || !('success' in payload) || payload.success !== true) {
    const detail = payload && 'error' in payload && payload.error ? payload.error : { code: 'API_ERROR', message: 'Unable to visualize RTL.', diagnostics: [], requestId: response.headers.get('X-Request-ID') ?? 'unknown' };
    throw new VisualizationError(detail, response.status);
  }
  return payload;
}
